export class PzoneCodeDto {
    eventType: string;
    province: string;
    trackName: string;
    pzoneCode: string;
    timezone:string;
}